<template>
  <el-dialog custom-class="max-dialog" title="管理产品" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false">
    <div class="grid-content bg-purple-light">
        <JxcgooddetailDetail ref="DataContactEdit" ></JxcgooddetailDetail>
        <el-table
          :data="tableData"
          :height="tableHeight(100)"
          size="mini"
          stripe @selection-change="handleSelectionChange"
          border
          style="width: 100%;">
          <el-table-column fixed
                           width="60"
                           label="序号"
                           align="center">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column fixed
                           prop="seedname"
                           label="名称" width="350" :show-overflow-tooltip="true"
                           align="left"
                           header-align="center">
          </el-table-column>
          <el-table-column
            prop="seedcode"
            label="编码"
            align="left"
            header-align="center"
            width="190">
          </el-table-column>
          <el-table-column
            prop="costprice" v-if="!newgood"
            label="供货价"
            align="right"
            header-align="center"
            width="100">
          </el-table-column>
          <el-table-column
          prop="minsellprice" v-if="!newgood"
          label="批发商售价"
          align="right"
          header-align="center"
          width="100">
        </el-table-column>
          <el-table-column
          prop="refsellprice"
          label="全国零售价"
          align="right"
          header-align="center"
          width="100">
        </el-table-column>
          <el-table-column
            prop="sname"
            label="分类"
            align="left" :show-overflow-tooltip="true"
            header-align="center"
            width="150">
          </el-table-column>
          <el-table-column label="状态" align="center" width="60">
            <template slot-scope="scope">
              <span v-bind:style="{color:scope.row.enabled == 0?'red':'gray'}"> {{scope.row.enabled == 0 ? "下架":"上架"}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sortnum"
            label="排序"
            align="left"
            header-align="center"
            width="70">
          </el-table-column>
          <el-table-column
            label="光度范围"
            align="left"
            width="200"
            header-align="center">
            <template slot-scope="scope">
              <span> {{Showpackagesize(scope.row.packagesize)}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" v-if="!newgood&&needaudit != 80"
                           type="selection"
                           width="55">
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           align="center" width="80">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="passData" :loading="loading" v-if="!newgood">审核通过</el-button>
      <el-button type="primary" @click="applyLaunch" :loading="loading" v-if="newgood&&!goodexist">申请开通</el-button>
      <span v-if="newgood&&goodexist"><strong>&nbsp;  &nbsp;{{showinfo}}</strong></span>
    </div>
  </el-dialog>
</template>
<script>
  import JxcgooddetailDetail from './JxcgooddetailDetail';
  import {getListfixcilumn,auditSupply} from '@/api/set/jxcgooddetail';
  import {saveupdate, getDetail} from '@/api/set/jxcgoodscategory';

  export default {
    name: 'JxcgooddetailAudit',
    data() {
      return {
        showinfo:'',
        newgood:false,
        goodexist:false,
        loadjingjia: false,
        activeCategory:'',
        categoryChild:[],
        categorycode:'',
        categoryname:'',
        needaudit: "",
        tenantid:"",
        nostock: "",
        dialogFormVisible: false,
        searchdata: "",
        loading: true,
        guids: '',
        gn: [],
        gorycodedata: [],//选择类别后的参数
        tableData: [],
        multipleSelection:[],
      }
    },
    methods: {
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      show(data){
        this.loading=false;
        this.newgood=data.newgood;
        this.goodexist=true;
        this.multipleSelection=[];
        this.showinfo=''
        this.dialogFormVisible=true;
        this.categorycode=data.categorycode;
        this.categoryname=data.categoryname;
        this.needaudit=data.needaudit?data.needaudit:'';
        this.tenantid=data.tenantid;
        if(this.newgood){
          getDetail({categorycode:data.categorycode}).then(response=>{
            this.goodexist=false;
            if(response.data.code==0&&response.data.obj&&response.data.obj.categorycode==data.categorycode) {
              this.goodexist = true;
              if (response.data.obj.categoryname == data.categoryname) {
                this.showinfo = '已发起申请，请等待找眼镜网审核！';
                if(!response.data.obj.supplytenantid){
                  this.goodexist = false;
                }else{
                  if(response.data.obj.supplytenantid!='waitaudit'){
                    this.showinfo = '已审核通过！';
                  }
                }
              } else {
                this.showinfo = '品牌编码' + data.categorycode + '冲突，请联系管理员！';
              }
            }
          })
        }
        this.bindGrid();
      },
      applyLaunch() {//申请开通
        this.loading = true;
        saveupdate({categorycode: this.categorycode, categoryname: this.categoryname}).then(response => {
          this.$message({
            type: 'success',
            message: '已发起申请，请等待找眼镜网审核！'
          });
          this.dialogFormVisible = false;
        })
      },
      passData() {
        if (this.multipleSelection.length == 0&&this.needaudit != 80) {
          this.$message({
            type: 'error',
            message: '请选择审核记录！'
          });
          return false;
        }

        var sc = '';
        for (let i in this.multipleSelection) {
          sc += this.multipleSelection[i].seedcode + ';';
        }
        this.loading = true;
        auditSupply({tenantid: this.tenantid, needaudit: this.needaudit, seedcode: sc,categorycode:this.categorycode}).then(response => {
          this.dialogFormVisible = false;
          this.$message({
            type: 'success',
            message: '审核完成！'
          });
          this.$emit('bindGrid');
        })
      },
      Showpackagesize(data) {
        var Rtn = '';
        if (data && data != '') {
          try {
            var qp = JSON.parse(data);
            if ((qp.YStart != 0 && qp.YStart != '0') || (qp.YEnd != 0 && qp.YEnd != '0')) {
              Rtn += this.GetNumber(qp.YStart) + '~' + this.GetNumber(qp.YEnd)
            }
            if (qp.XEnd && qp.XEnd != 0) {
              Rtn += ",cyl" + this.GetNumber(qp.XEnd)
            }
            if (qp.Union && qp.Union != 0) {
              Rtn += ",联合" + this.GetNumber(qp.Union)
            }
          } catch (ex) {}
        }
        return Rtn;
      },
      GetNumber(num) {
        if (num == null || num == 0 || num == '0')
          return '0.00';
        return this.numeric(num, 2)
      },
      Showformproperty(data) {
        var Rtn = '';
        if (data && data != '') {
          var qp = JSON.parse(data);
          for (var i = 0; i < qp.length; i++) {
            Rtn += qp[i].name + qp[i].item + ' ';
          }
        }
        return Rtn;
      },
      Showqueryproperty(data) {
        var Rtn = '';
        if (data && data != '') {
          var qp = JSON.parse(data);
          for (var i = 0; i < qp.length; i++) {
            Rtn += qp[i].item + ' ';
          }
        }
        return Rtn;
      },
      handleEdit(index, row) {
        this.$refs.DataContactEdit.initData(row)
        this.OpenDialog();
      },
      bindGrid() {
        getListfixcilumn({
          searchdata: '',
          categorycode: this.categorycode,
          needaudit: this.needaudit == 80 ? '' : this.needaudit,
          tenantid: this.needaudit == 80 ? '' : this.tenantid,
          nostock: ''
        }).then(response => {
          this.tableData = response.data.obj.rows
        }).catch((error) => {
          console.log(error)
        });
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show()
      },
    },
    mounted() {
    },
    components: {
      JxcgooddetailDetail,
    }

  }
</script>


<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/set/jxcgooddetail/JxcgooddetailAudit.vue